<script setup>
import UiBadge from '@/components/ui/UiBadge.vue'

/** A stage's, an activation's or an agreement's invoicing at a glance (D-216): overdue, due, invoiced. */
defineProps({ marks: { type: Object, required: true } })
</script>

<template>
  <span v-if="marks.any" class="inline-flex flex-wrap items-center gap-1" data-testid="billing-marks">
    <UiBadge v-if="marks.overdue" tone="red" icon="fa-file-invoice-dollar">{{ $t('billing.marks.overdue', { n: marks.overdue }) }}</UiBadge>
    <UiBadge v-if="marks.due" tone="amber" icon="fa-file-invoice-dollar">{{ $t('billing.marks.due', { n: marks.due }) }}</UiBadge>
    <UiBadge v-if="marks.invoiced && !marks.overdue && !marks.due" tone="green" icon="fa-file-invoice-dollar">{{ marks.number ? $t('billing.marks.invoicedAs', { number: marks.number }) : $t('billing.marks.invoiced', { n: marks.invoiced }) }}</UiBadge>
  </span>
</template>
